import * as moment from 'moment';

export const dateHoursAgo = (hours: number): string => {
  return moment()
    .startOf('hour')
    .subtract(hours, 'hour')
    .format();
};

export const dateDaysAgo = (days: number): string => {
  return moment()
    .startOf('day')
    .subtract(days, 'day')
    .startOf('day')
    .format();
};
